"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.circle_question = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var circle_question = function circle_question(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'circle-question-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M10 3.75C6.54822 3.75 3.75 6.54822 3.75 10C3.75 13.4518 6.54822 16.25 10 16.25C13.4518 16.25 16.25 13.4518 16.25 10C16.25 6.54822 13.4518 3.75 10 3.75ZM2.25 10C2.25 5.71979 5.71979 2.25 10 2.25C14.2802 2.25 17.75 5.71979 17.75 10C17.75 14.2802 14.2802 17.75 10 17.75C5.71979 17.75 2.25 14.2802 2.25 10Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M9.68555 12.1699C10.1504 12.1699 10.3828 11.8896 10.4512 11.4385C10.5059 10.8164 10.7246 10.4883 11.6201 9.96875C12.5498 9.41504 13.0693 8.69727 13.0693 7.65137C13.0693 6.10645 11.7979 5.05371 9.94531 5.05371C8.53711 5.05371 7.4707 5.62793 7.04688 6.55762C6.91699 6.81738 6.85547 7.07031 6.85547 7.36426C6.85547 7.82227 7.13574 8.10938 7.60742 8.10938C7.9834 8.10938 8.23633 7.93848 8.38672 7.51465C8.60547 6.82422 9.11133 6.44824 9.87012 6.44824C10.7109 6.44824 11.292 6.96777 11.292 7.71289C11.292 8.36914 11.0049 8.74512 10.1572 9.25781C9.30273 9.76367 8.87891 10.3242 8.87891 11.1719V11.3018C8.87891 11.8008 9.16602 12.1699 9.68555 12.1699ZM9.69922 15.1367C10.2529 15.1367 10.6904 14.7061 10.6904 14.166C10.6904 13.626 10.2529 13.2021 9.69922 13.2021C9.14551 13.2021 8.70117 13.626 8.70117 14.166C8.70117 14.7061 9.14551 15.1367 9.69922 15.1367Z',
    fill: '#4B5563'
  }));
};

exports.circle_question = circle_question;